import { render, staticRenderFns } from "./characteristics.create.component.vue?vue&type=template&id=0688f1e3&scoped=true&"
import script from "./characteristics.create.component.vue?vue&type=script&lang=js&"
export * from "./characteristics.create.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688f1e3",
  null
  
)

export default component.exports